/** API のエラーコード（設計書 §7.3）。画面の分岐に使うものだけ列挙する */
export const API_ERROR_CODE = {
  ACCOUNT_EMAIL_EXISTS: 'ACCOUNT_EMAIL_EXISTS',
  ADMIN_SINGLE_MEMBERSHIP: 'ADMIN_SINGLE_MEMBERSHIP',
  ACTIVE_ADMIN_REQUIRED: 'ACTIVE_ADMIN_REQUIRED',
  SELF_MEMBERSHIP_PAUSE_FORBIDDEN: 'SELF_MEMBERSHIP_PAUSE_FORBIDDEN',
} as const;

export type ApiErrorCode =
  (typeof API_ERROR_CODE)[keyof typeof API_ERROR_CODE];

/** axios のレスポンスエラーから `{ code }` を取り出す。無ければ undefined */
export const getApiErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const data = (error as { response?: { data?: unknown } | null }).response
    ?.data;
  if (typeof data !== 'object' || data === null) return undefined;
  const code = (data as { code?: unknown }).code;
  return typeof code === 'string' ? code : undefined;
};

/** 409 `ACCOUNT_EMAIL_EXISTS` が返す既存 Account の ID（無ければ undefined） */
export const getApiErrorAccountId = (error: unknown): number | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const data = (error as { response?: { data?: unknown } | null }).response
    ?.data;
  if (typeof data !== 'object' || data === null) return undefined;
  const accountId = (data as { accountId?: unknown }).accountId;
  return typeof accountId === 'number' && Number.isInteger(accountId)
    ? accountId
    : undefined;
};
